import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=60128524&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=60128524&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60128524",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/crm1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60128524')) {
      api.createRecord('60128524', component.options)
    } else {
      api.reload('60128524', component.options)
    }
    module.hot.accept("./AdminLayout.vue?vue&type=template&id=60128524&scoped=true", function () {
      api.rerender('60128524', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/AdminLayout.vue"
export default component.exports